import Api from '@/apis/api';

export default {
  namespaced: true,
  state: {
    corpsList: [],
    oralStatus: [
      { text: '정상', value: 'S' },
      { text: '주의', value: 'G' },
      { text: '약간위험', value: 'A' },
      { text: '위험', value: 'D' },
    ],
    joinStatus: [
      { text: '가입', value: 'Y' },
      { text: '미가입', value: 'N' },
    ],
    genderStatus: [
      { text: '남자', value: 'M' },
      { text: '여자', value: 'W' },
    ],
    certStatus: [
      { text: '회원', value: 'Y' },
      { text: '비회원', value: 'N' },
    ],
    cellRangeItems: [
      { text: '10개씩 보기', value: 10 },
      { text: '50개씩 보기', value: 50 },
      { text: '100개씩 보기', value: 100 },
    ],
    userListHeaders: [
      { text: '번호', align: 'start', value: 'num' },
      { text: '이름', value: 'name' },
      { text: '아이디(연락처)', value: 'number' },
      { text: '생년월일', value: 'birth', width: '130px' },
      { text: '성별', value: 'gender', width: '80px' },
      { text: '총 촬영횟수', value: 'totalCount' },
      { text: '최근 촬영일시', value: 'latestDate' },
      { text: '최근 잇몸상태', value: 'latestState' },
      { text: '회원여부', value: 'isCertified' },
      { text: '기능', value: 'tools', sortable: false },
    ],
    adminListHeaders: [
      { text: '번호', align: 'start', value: 'num' },
      { text: '관리자', value: 'name' },
      { text: '연락처', value: 'tel' },
      { text: '아이디', value: 'loginid' },
      { text: '가입일', value: 'created' },
      { text: '', value: 'tools', sortable: false },
    ],
    oralStatusListHeaders: [
      { text: '양치시간(구강촬영일시)', value: 'date', sortable: false },
      { text: '구강상태', value: 'soldierState', sortable: false },
      { text: '구강등급(상위)', value: 'percent', sortable: false },
    ],
    statisticsRankListHeaders: [
      { text: '우수 양치습관 순위', value: 'index', sortable: false },
      { text: '부대', value: 'corName', sortable: false },
      { text: '이름', value: 'name', sortable: false },
      { text: '구강촬영횟수', value: 'count', sortable: false },
      { text: '평균 구강상태', value: 'state', sortable: false },
      { text: '지역 내 구강건강 최고 순위 (플라그 체크)', value: 'oralConditionRank', sortable: false },
      { text: '최근 구강촬영일시)', value: 'latestDate', sortable: false },
    ],
    healthStatus: {
      S: {
        text: '정상',
        paragraph: '정상입니다',
        value: 4,
        color: '#337eff',
        icon: 'health',
        description: '양치질을 전문가<br/>수준으로 잘하셨어요!',
        infoText: '화살표 방향이 바뀌지 않도록<br/>양치를 계속 잘해주세요.',
      },
      G: {
        text: '주의',
        paragraph: '주의입니다',
        value: 3,
        color: '#27c4aa',
        icon: 'good',
        description: '정확한 양치 습관을<br/>가지고 있어요!',
        infoText: '화살표가 위로 향할 수 있도록<br/>조금만 힘내주세요.',
      },
      A: {
        text: '약간위험',
        paragraph: '약간위험입니다',
        value: 2,
        color: '#fcb519',
        icon: 'caution',
        description: '올바른 양치질 필요!<br/>진돗개 둘 발령',
        infoText: '건강한 구강상태로<br/>돌아올 수 있도록 더 노력해 보세요.',
      },
      D: {
        text: '위험',
        paragraph: '위험입니다',
        value: 1,
        color: '#e64e81',
        icon: 'warning',
        description: '치아에 적군이 득실!<br/>진돗개 하나 발령',
        infoText: '구강상태가 하향세입니다.<br/>양치에 더욱 신경써주세요.',
      },
    },
  },
  mutations: {
    setCorpsList(state, corpsList) {
      state.corpsList = corpsList;
    },
  },
  actions: {
    fetchCorpsList({ commit }) {
      Api.getCorps().then(res => {
        if (res && res.data.rt === 200) {
          commit('setCorpsList', res.data.corpsList);
        } else {
          alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요. 오류 코드 : ' + res.data.rt);
        }
      });
    },
  },
};
